export default {
  getChannelToken: function (state) {
    return state.channelToken
  },
  getChannel: function (state) {
    return state.channel
  },
  getCheckManagePage: function (state) {
    return state.checkManagePage
  }
}
